import { c as _c } from "react/compiler-runtime";
import useFavoritedProductIds from 'hooks/useFavoritedProductIds';
import useStaticWishlistData from './useStaticWishlistData';
const useFavoritesStaticProductData = () => {
  const $ = _c(4);
  const {
    data
  } = useFavoritedProductIds();
  let t0;
  if ($[0] !== data?.productIds) {
    t0 = data?.productIds ?? [];
    $[0] = data?.productIds;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const productIds = t0;
  let t1;
  if ($[2] !== productIds) {
    t1 = {
      productIds
    };
    $[2] = productIds;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return useStaticWishlistData(t1);
};
export default useFavoritesStaticProductData;